import { getRgObjectsOfType as r, RG_TYPE as t } from "@project-rouge/rg-core";
import { getArea as c } from "../index3.js";
import { isServiceTechSpace as i } from "../../queries/index7.js";
const a = (e) => c(r(e, t.TechnicalSpace).filter(i));
export {
  a as getServicesArea
};
//# sourceMappingURL=index53.js.map
